import { Controller } from "@hotwired/stimulus"

// Steps through a row of screenshots (Site::Carousel). The track is a
// scroll-snap strip that swipes on its own; this moves it from the buttons and
// marks which slide is showing as the reader scrolls. Slides off screen are
// inert, so tabbing does not land on a screenshot nobody can see.
export default class extends Controller {
  static targets = ["track", "slide", "tab", "previous", "next"]

  connect() {
    this.index = 0
    this.onScroll = () => {
      cancelAnimationFrame(this.frame)
      this.frame = requestAnimationFrame(() => this.sync())
    }
    this.trackTarget.addEventListener("scroll", this.onScroll, { passive: true })
    this.sync()
  }

  disconnect() {
    this.trackTarget.removeEventListener("scroll", this.onScroll)
    cancelAnimationFrame(this.frame)
  }

  previous() {
    this.go(this.index - 1)
  }

  next() {
    this.go(this.index + 1)
  }

  show(event) {
    this.go(event.params.index)
  }

  go(index) {
    const target = Math.max(0, Math.min(index, this.slideTargets.length - 1))
    const smooth = !window.matchMedia("(prefers-reduced-motion: reduce)").matches
    this.trackTarget.scrollTo({ left: target * this.trackTarget.clientWidth, behavior: smooth ? "smooth" : "auto" })
  }

  sync() {
    const width = this.trackTarget.clientWidth
    this.index = width ? Math.round(this.trackTarget.scrollLeft / width) : 0
    const last = this.slideTargets.length - 1

    this.tabTargets.forEach((tab, i) => tab.setAttribute("aria-current", String(i === this.index)))
    this.slideTargets.forEach((slide, i) => { slide.inert = i !== this.index })
    this.previousTarget.disabled = this.index === 0
    this.nextTarget.disabled = this.index >= last
  }
}
